export type FuzzyMatch = { score: number; indices: number[] };

const WORD_BREAK = /[\s\-_./(),&]/;

export function fuzzyMatch(query: string, text: string): FuzzyMatch | null {
  const q = query.toLowerCase();
  const t = text.toLowerCase();
  const indices: number[] = [];
  let score = 0;
  let ti = 0;
  for (const ch of q) {
    while (ti < t.length && t[ti] !== ch) ti++;
    if (ti >= t.length) return null;
    score += 1;
    if (ti === 0) score += 3;
    else if (WORD_BREAK.test(text[ti - 1]!)) score += 2;
    if (indices.length > 0 && indices[indices.length - 1] === ti - 1) score += 2;
    indices.push(ti);
    ti++;
  }
  return { score, indices };
}

export function fuzzyRank<T>(query: string, items: readonly T[], key: (item: T) => string): T[] {
  return items
    .map((item) => ({ item, match: fuzzyMatch(query, key(item)) }))
    .filter((x): x is { item: T; match: FuzzyMatch } => x.match !== null)
    .sort((a, b) => b.match.score - a.match.score || key(a.item).localeCompare(key(b.item)))
    .map((x) => x.item);
}
